import React from 'react';
import ReactDOM from 'react-dom';

import '@amzn/awsui-global-styles/polaris.css';
import 'AWS-UI-Components-React/index.css';
import './styles/index.css';

import App from './App';
import {applyDensity, applyMode, Density, Mode} from "@amzn/awsui-global-styles";

applyDensity(Density.Compact);
//applyMode(Mode.Dark);
ReactDOM.render(<App />, document.getElementById('root')); // eslint-disable-line react/jsx-filename-extension



// WEBPACK FOOTER //
// ./src/index.js